/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react";
import { MaterialUIControllerProvider } from "context";
import { AuthProvider } from "./context/auth-context";
import { Provider } from "react-redux";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import store from "store";
import App from "./App";
import LanguageProvider from './store/LanguageProvider';
// Material Dashboard 2 React Context Provider

const container = document.getElementById("app");
const root = createRoot(container);
//  <Provider store={store}>

root.render(
  <>
  <Provider store={store}>
    <BrowserRouter>
      <MaterialUIControllerProvider>
        <LanguageProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </LanguageProvider>
      </MaterialUIControllerProvider>
    </BrowserRouter>
  </Provider>
  </>
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        // console.log('ServiceWorker registration successful');
      })
      .catch((err) => {
        console.log('ServiceWorker registration failed: ', err);
      });
  });
}